module Meevo.Plugins.AppointmentBook {
    class ColumnOrderController {
        items: any[];
        filteredItems: any;
        selectedItem: any;
        baseEndPoint: any;
        employeeCategoryIds: any = [];

        private shortCutGroup: IShortCutGroup;
        //defaultAppointmentBookOrder = 999999;
        static $inject = [
            'meevo.components.common.DataService',
            'appointmentBookModalService',
            'Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
            'appointmentBookGlobalsService',
            '$filter',
            'meevo.components.short-cuts.ShortCutsService'
        ];

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modal,
            private filterService,
            private globals,
            protected $filter: ng.IFilterService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
        ) {
            let request : any = {
                pageNumber: 0,
                itemsPerPage: 1000, // TODO: Need way to specify that I want a full list
                sortDirection: Model.SortDirection.Ascending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            };

            this.employeeCategoryIds = _.pluck(this.filterService.filteredEmployeeCategories, 'id');

            if (globals.isEmployeeView) {
                this.baseEndPoint = "AppointmentBook/EmployeeColumnOrder";
                request.criteria = {
                    showEmployeesOnly: true
                }
                request.employeeCategoryIds = this.employeeCategoryIds;
                if (globals.initializingColumnOrderDialog) {
                    // the constructor is getting called twice, this is a workaround to stop the second call from getting inside
                    globals.initializingColumnOrderDialog = false;
                    this.dataService.trackUsage(Model.NounEnum.EmployeeColumnOrder, Model.VerbEnum.Viewed, null);
                }
            } else {
                this.baseEndPoint = "Resource";
                request.sortBy = 'AppointmentBookOrder';
                if (globals.initializingColumnOrderDialog) {
                    // the constructor is getting called twice, this is a workaround to stop the second call from getting inside
                    globals.initializingColumnOrderDialog = false;
                    this.dataService.trackUsage(Model.NounEnum.ResourceColumnOrder, Model.VerbEnum.Viewed, null);
                }
            }

            
            this.dataService.getListPaged(this.baseEndPoint, request).then((response: any[]) => {
                this.items = response;
                
                for (let i = 0; i < this.items.length; i++){
                    const item = this.items[i];
                    item.isSelectable = (this.employeeCategoryIds.length == 0 || item.inCategoryList);
                }
            });

            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: 'MODAL_SAVE_BUTTON',
                    callback: () => {
                        this.save();
                    }
                },
                {
                    shortCutName: 'MODAL_CANCEL_BUTTON',
                    callback: () => {
                        this.cancel();
                    }
                }
            ], {
                groupLevel: Components.ShortCuts.GroupLevels.Modal,
                deactivateGlobal: true,
            });

            this.shortCutsService.activateGroup(this.shortCutGroup);
        }

        select(item) {
            this.selectedItem = item;
        }

        moveLeftEnd() {
            if (!this.selectedItem) {
              return;
            }
            const itemCopy = this.items.splice(this.items.indexOf(this.selectedItem), 1)[0];
            this.items.splice(0, 0, itemCopy);
        }

        moveLeft() {
            if (!this.selectedItem) {
              return;
            }

            const selectedIndex = this.items.indexOf(this.selectedItem);
            if (selectedIndex === 0) {
                return;
            }
            
            this.moveFunc(this.selectedItem, this.items[selectedIndex-1]);
        }

        moveRight() {
            if (!this.selectedItem) {
              return;
            }

            const selectedIndex = this.items.indexOf(this.selectedItem);            
            if (selectedIndex === this.items.length-1) {
                return;
            }
            
            this.moveFunc(this.selectedItem, this.items[selectedIndex + 1]);
        }

        moveRightEnd() {
            if (!this.selectedItem) {
              return;
            }

            const itemCopy = this.items.splice(this.items.indexOf(this.selectedItem), 1)[0];
            this.items.push(itemCopy);
        }

        private moveFunc(selectedItem, leftOrRightItem): void {
            if(!selectedItem || !leftOrRightItem){
                return;
            }
            
            const leftOrRightItemIndex = this.items.indexOf(leftOrRightItem);
            const selectedItemIndex = this.items.indexOf(this.selectedItem);

            this.items[selectedItemIndex] = this.items[leftOrRightItemIndex];
            this.items[leftOrRightItemIndex] = this.selectedItem;
        }

        clear() {
            this.selectedItem = undefined;
        }

        save()
        {
            if (this.globals.isEmployeeView)
            {
                this.baseEndPoint = "Employee";
            }

            const requestitems = this.buildRequestItems();

            this.dataService.patchArray(this.baseEndPoint, requestitems)
                .then((response: any) =>
            {
                this.shortCutsService.deactivateGroup(this.shortCutGroup);
                this.modal.hideModal();
                this.filterService.refresh();
            });
        }

        private buildRequestItems(): any[]
        {
            if(!this.items) { 
                return [];
            }

            let requestitems = [];

            for (let i = 0; i < this.items.length; i++){
                const current = this.items[i];
                const position = i + 1;

                if (current.appointmentBookOrder !== position){
                    const requestItem = {
                        id: current.id,
                        model: { AppointmentBookOrder: position }
                        };

                    requestitems.push(requestItem);
                }
            }

            return requestitems;
        }

        getDisplay(item) {
            if (this.globals.isEmployeeView) {
                return item.code;
            } else {
                return item.shortcut;
            }
        }

        getImageUrl(item, defaultUri) {
            return Model.StorageFileHelper.imageUri({
                meevoFile: item.meevoFile,
                fileGuid: item.employeeImage,
                contentType: 'image/png',              
            }, defaultUri);
        }

        cancel() {
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
            this.modal.hideModal();
        }
    }

    angular.module("ApptBookApp").controller("ColumnOrderController", ColumnOrderController);
}